import React from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';

interface ActivityErrorBannerProps {
  message: string;
}

const ActivityErrorBanner: React.FC<ActivityErrorBannerProps> = ({ message }) => (
  <Alert variant="destructive" className="mb-4">
    <AlertDescription className="revy-cjk leading-[1.6]">{message}</AlertDescription>
  </Alert>
);

export default ActivityErrorBanner;
